export enum PaymentMethodEnum {
  Cash = 1,
  CreditCard = 2,
  Credits = 4,
  //...
  Square = 14,
  //...
  GiftCard = 23,
  //...
  ePay = 27,
}
